import request from './request'
import type {
  Statistics,
  OTARecord,
  OTAConfig,
  UpgradeResult,
  DevicesResponse,
  LogsResponse,
  OTARecordsResponse,
  CommandResponse,
  Device
} from '../types/device'

export const deviceApi = {
  // 设备列表
  getDevices: () => 
    request.get<DevicesResponse>('/devices'),
  
  getDevice: (deviceId: string) => 
    request.get<Device>(`/devices/${deviceId}`),
  
  addDevice: (deviceId: string) => 
    request.post('/devices', { device_id: deviceId }),
  
  updateDevice: (deviceId: string, data: Partial<Device>) => 
    request.put(`/devices/${deviceId}`, data),
  
  // 设备状态
  getDeviceStatus: (deviceId: string) => 
    request.get(`/devices/${deviceId}/status`),
  
  requestDeviceStatus: (deviceId: string) => 
    request.get(`/devices/${deviceId}/status/request`),
  
  // 设备日志
  getDeviceLogs: (deviceId: string, params?: { limit?: number; level?: string }) => 
    request.get<LogsResponse>(`/devices/${deviceId}/logs`, { params }),
  
  // 设备配置
  getDeviceConfig: (deviceId: string) => 
    request.get<CommandResponse>(`/devices/${deviceId}/config`),
  
  updateDeviceConfig: (deviceId: string, config: Record<string, any>) => 
    request.post<CommandResponse>(`/devices/${deviceId}/config`, config),
  
  // 设备命令
  sendCommand: (deviceId: string, action: string, payload?: Record<string, any>) => 
    request.post<CommandResponse>(`/devices/${deviceId}/command`, { action, payload }),
  
  // OTA
  getOTAConfig: () => 
    request.get<OTAConfig>('/ota/config'),
  
  updateOTAConfig: (config: Partial<OTAConfig>) => 
    request.put('/ota/config', config),
  
  upgradeDevice: (deviceId: string, force?: boolean) => 
    request.post<UpgradeResult>(`/devices/${deviceId}/ota/upgrade`, { force }),
  
  upgradeAllDevices: (force?: boolean) => 
    request.post<{ success: boolean; upgraded: string[]; skipped: string[]; total: number }>('/devices/ota/upgrade_all', { force }),
  
  getUpgradeStatus: (deviceId: string) => 
    request.get<{
      device_id: string
      firmware_version: string
      target_version: string
      upgrade_status: string
      auto_upgrade_enabled: boolean
      is_upgrading: boolean
      recent_records: OTARecord[]
    }>(`/devices/${deviceId}/ota/status`),
  
  setAutoUpgrade: (deviceId: string, enabled: boolean) => 
    request.put<{ success: boolean; device_id: string; auto_upgrade_enabled: boolean }>(`/devices/${deviceId}/ota/auto_upgrade`, { enabled }),
  
  getOTARecords: (params?: { limit?: number; device_id?: string }) => 
    request.get<OTARecordsResponse>('/ota/records', { params }),
  
  // 统计
  getStatistics: () => 
    request.get<Statistics>('/statistics'),
  
  // 批量操作
  requestAllStatus: () => 
    request.post<{ command_id: string; message: string; checked_devices: number }>('/devices/request_all_status'),
  
  requestAllConfig: (delayMs?: number) => 
    request.post<{ device_count: number; estimated_time_ms: number; delay_ms: number; message: string }>('/devices/request_all_config', { delay_ms: delayMs }),
  
  requestAll: () => 
    request.post<{ status_command_id: string; config_device_count: number; config_estimated_time_ms: number; message: string }>('/devices/request_all'),
  
  broadcastCommand: (action: string, payload?: Record<string, any>) => 
    request.post<CommandResponse>('/broadcast', { action, payload }),
}
